import * as React from 'react'
import styled from 'styled-components'
import { INavigationItem } from 'shared-interfaces'
import IpadAndMobileDisplay from '@/components/templates/displays/ipadAndMobileDisplay'
import BtnWIconNBgNoBorder from '@/components/atoms/buttons/btnWIconNBgNoBorder'
import SideSlider from '@/components/templates/animated/sideSlider'

import SolidBorderWhiteBgButton from '@/components/atoms/buttons/solidBorderWhiteBg'
import { motion } from 'framer-motion'
import StatefulHamburgerIcon from '@/components/atoms/icons/statefulHamburgerIcon'
import CenterAlignLogo from '@/components/atoms/logo/centeralignLogo'
import { device } from '@/components/templates/displays/devices'
import posthog from 'posthog-js'

const Wrapper = styled.div<IStyle>`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100vh;
    background-color: white;
    z-index: 10;
    overflow-y: auto;
    display: flex;
    align-items: center;
    justify-content: center;
`
const SubWrapper = styled.div<IStyle>`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    padding: 30px;
    @media ${device.ipad} {
        max-width: 500px;
    }
`

const BtnsWrapper = styled.div<IStyle>`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    transition: all 100ms;
    padding-bottom: 30px;
`

const TopSectionWrapper = styled.div<IStyle>`
    width: 100%;
`

const BottomSectionWrapper = styled.div<IStyle>`
    width: 100%;
    padding-bottom: 10px;
    @media ${device.ipad} {
        padding-bottom: 6vh;
    }
`

const CentralLogoWrapper = styled.div<IStyle>`
    width: 100%;
    padding-top: 5vh;
    padding-bottom: 50px;
    @media ${device.ipad} {
        padding-top: 6vh;
    }
    @media (max-width: 320px) {
        padding-top: 20px;
        padding-bottom: 40px;
    }
`

const MenuIconWrapper = styled(motion.div)`
    position: absolute;
    top: 20px;
    right: 20px;
    padding-left: 10px;
`

const NotRegistered = styled.div`
    font-family: Lato-light;
    width: 100%;
    padding-top: 30px;
    padding-bottom: 10px;
    font-size: 14px;
    @media (max-width: 320px) {
        font-size: 12px;
    }
`

const SignUp = styled.a`
    font-family: Lato;
    width: 100%;
    color: #00a9af;
    @media (max-width: 320px) {
        font-size: 15px;
    }
`

interface Props {
    menu_data: INavigationItem[]
    onCrossClick: any
    isOpen: boolean
}

interface IStyle {}

const MobilePlatformMenu: React.FunctionComponent<Props> = (props) => {
    const { menu_data, isOpen } = props

    let screenWidth = window && window.innerWidth

    return (
        <SideSlider
            initial="enter"
            direction="right"
            customZIndex={10}
            isVisible={isOpen}
        >
            <IpadAndMobileDisplay>
                <Wrapper>
                    <SubWrapper>
                        <TopSectionWrapper>
                            <MenuIconWrapper
                                whileTap={{ scale: 1.1 }}
                                onClick={props.onCrossClick}
                            >
                                <StatefulHamburgerIcon isOpen={isOpen} />
                            </MenuIconWrapper>

                            <CentralLogoWrapper>
                                <CenterAlignLogo />
                            </CentralLogoWrapper>
                            <BtnsWrapper>
                                {menu_data.map((menuItem, index) => (
                                    <div key={index} style={{ width: '100%' }}>
                                        <a
                                            href={menuItem.url}
                                            style={{ width: '100%' }}
                                            target="_blank"
                                            rel="noreferrer"
                                        >
                                            <BtnWIconNBgNoBorder
                                                text={menuItem.pageName}
                                                onClick={() => {
                                                    posthog.capture(
                                                        'public viewer navigates to external link:',
                                                        {
                                                            to: menuItem.pageName,
                                                        }
                                                    )
                                                }}
                                                icon={menuItem.icon}
                                                height="55px"
                                                dataAttId={`${menuItem.id}_platfom_menu_item`}
                                            />
                                        </a>
                                        <div
                                            style={{ paddingBottom: '10px' }}
                                        />
                                    </div>
                                ))}
                            </BtnsWrapper>
                        </TopSectionWrapper>
                        <BottomSectionWrapper>
                            <a
                                href="https://app.custodian.club/login"
                                style={{ width: '100%' }}
                                target="_blank"
                                rel="noreferrer"
                            >
                                <SolidBorderWhiteBgButton
                                    text={'Login'}
                                    width="100%"
                                    height={screenWidth > 320 ? '50px' : '45px'}
                                    onClick={() => {
                                        posthog.capture(
                                            'public viewer navigates to external link:',
                                            {
                                                to: '/login',
                                            }
                                        )
                                    }}
                                    dataAttId="login_btn_mobile"
                                />
                            </a>
                            <NotRegistered>Not registered?</NotRegistered>
                            <SignUp
                                href="https://app.custodian.club/register"
                                target="_blank"
                                rel="noreferrer"
                            >
                                <div
                                    onClick={() => {
                                        posthog.capture(
                                            'public viewer navigates to external link:',
                                            {
                                                to: '/register',
                                            }
                                        )
                                    }}
                                    data-attr="register_btn_mobile"
                                >
                                    Sign up
                                </div>
                            </SignUp>
                        </BottomSectionWrapper>
                    </SubWrapper>
                </Wrapper>
            </IpadAndMobileDisplay>
        </SideSlider>
    )
}

export default MobilePlatformMenu
